import React from "react";

const DeletePopupuo = ({ handleDeleteConfirm, handleDeleteCancel }) => {
  return (
    <div
      className="vw-100 vh-100 position-fixed top-0 start-0 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.4)", 
        zIndex: 1000
      }}
    >
      <div
        className="d-flex bg-white rounded-3 border border-primary flex-column justify-content-between align-items-start p-3"
        style={{
          width: "450px",
          height: "250px",
          zIndex: 1010 
        }}
      >
        <div className="py-2">Delete</div>
        <p className="fs-5 fw-bold">
          Are you sure you want to delete this item?
        </p>
        <div className="flex-row px-5 d-flex justify-content-between align-items-center w-100">
          <span
            className="btn border border-primary rounded-pill px-4 py-2"
            onClick={handleDeleteCancel}
          >
            Cancel
          </span>
          <span
            className="btn btn-danger text-white border border-primary rounded-pill px-4 py-2"
            onClick={handleDeleteConfirm}
          >
            Delete
          </span>
        </div>
      </div>
    </div>
  );
};

export default DeletePopupuo;
